const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
const toTitleCase = (string) => string
    .toString()
    .trim()
    .replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, (match, index, title) => {
    if (index > 0
        && index + match.length !== title.length
        && match.search(smallWords) > -1
        && title.charAt(index - 2) !== ':'
        && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-')
        && title.charAt(index - 1).search(/[^\s-]/) < 0) {
        return match.toLowerCase();
    }
    // noinspection JSDeprecatedSymbols
    if (match.substr(1).search(/[A-Z]|\../) > -1) {
        return match;
    }
    // noinspection JSDeprecatedSymbols
    return match.charAt(0).toUpperCase() + match.substr(1);
});
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
const mightBeEmail = (s) => typeof s === 'string' && s.indexOf('@') !== -1;
const redacted = 'REDACTED (Potential Email Address)';
const redactEmail = (string) => {
    if (mightBeEmail(string)) {
        globalThis.console.warn('This arg looks like an email address, redacting.');
        return redacted;
    }
    return string;
};
const format = (s = '', titleCase = true, redactingEmail = true) => {
    let str = s || '';
    if (titleCase) {
        str = toTitleCase(s);
    }
    if (redactingEmail) {
        str = redactEmail(str);
    }
    return str;
};
export { format };
//# sourceMappingURL=format.js.map